export const settings = {
  breadcrumb: {
    root: 'Instellingen',
    invitations: 'Uitnodigingen',
    documents: 'Documenten',
    pricing: 'Vergoeding',
  },
  header: {
    title: 'Instellingen',
    save: 'Wijzigingen opslaan',
  },
  tabs: {
    profile: 'Profiel',
    email: 'Meldingen',
    invoice: 'Factuur instellingen',
    company: 'Bedrijfsgegevens',
    integrations: 'Integraties',
  },
  imageUpload: {
    logo: {
      delete: 'Logo verwijderen',
      label: 'Logo',
      upload: 'upload foto',
    },
    profilePicture: {
      delete: 'Foto verwijderen',
      label: 'Profiel foto',
      upload: 'upload nieuwe foto',
    },
  },
  unsavedChanges: {
    title: 'Je hebt niet-opgeslagen wijzigingen',
    description: 'Sla je wijzigingen op voor je verdergaat, of verwerp ze om zonder opslaan verder te gaan.',
    save: 'Wijzigingen opslaan',
    discard: 'Wijzigingen verwerpen',
  },
  accountCompletionModal: {
    action: {
      complete: 'Voltooien',
      next: 'Volgende',
      save: 'Opslaan',
    },
    description: 'Vul je gegevens aan, zodat je snel kan beginnen met factureren.',
    financialInfo: {
      description: 'Vul hieronder je IBAN-nummer in.',
      tab: 'Bankgegevens',
    },
    frameworkAgreement: {
      error: 'Er ging iets mis bij het tekenen van je overeenkomst.',
      tab: 'Raamovereenkomst',
    },
    peppol: {
      checkAgain: 'Check mijn Peppol-inbox',
      description:
        '<paragraph>Om facturen te verzenden via Creative Shelter heb je een <bold>actieve Peppol-inbox</bold> nodig. Die heb je op dit moment nog niet.</paragraph><paragraph>Zonder Peppol-inbox kunnen we je factuur niet verzenden. Activeer eerst je Peppol-inbox bij een erkende provider.</paragraph><paragraph>Zodra je Peppol-inbox geactiveerd is, kunnen wij je Peppol-ID automatisch terugvinden. Heb je dat al in orde gebracht? Dan kan je hieronder opnieuw laten checken.</paragraph>',
      tab: 'Peppol-inbox',
    },
    successModal: {
      createFirstInvoice: 'Maak eerste factuur',
      description: 'Je bent nu klaar om jouw factuur of offerte te verzenden!',
      title: 'Account aangevuld',
    },
    title: 'Vervolledig jouw account',
    vatRegulation: {
      error: 'Er ging iets mis bij het opslaan van je btw-status.',
      tab: 'Btw-status',
    },
  },
  alerts: {
    errorActivities: 'Er ging iets mis bij het opslaan van je activiteiten.',
    errorPersonalInfo: 'Er ging iets mis bij het opslaan van je profielinformatie.',
    invalidFields: 'Niet alles is correct ingevuld. Controleer de aangeduide velden.',
    brands: {
      successCreated: 'Je handelsnaam werd aangemaakt!',
      successDeleted: 'Je handelsnaam werd verwijderd!',
      successFavorite: 'Je favoriete handelsnaam werd gewijzigd!',
      successUpdated: 'Je handelsnaam werd gewijzigd!',
    },
    community: {
      errorProfilePictureDeleted:
        'Er ging iets mis bij het verwijderen van je Community profielfoto. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      errorProfilePictureTooLarge: 'De afbeelding die je probeert te uploaden mag niet groter zijn dan 5 MB.',
      errorProfilePictureUploaded:
        'Er ging iets mis bij het uploaden van je Community profielfoto. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      errorUpdated:
        'Er ging iets mis bij het updaten van je Community profiel. Neem contact op met service@creativeshelter.be als het probleem zich blijft voordoen.',
      successProfilePictureDeleted: 'Je Community profielfoto werd verwijderd!',
      successProfilePictureUploaded: 'Je Community profielfoto werd gewijzigd!',
    },
    customConditions: {
      successDeleted: 'De custom algemene voorwaarde werd succesvol verwijderd!',
    },
    integrations: {
      successAccountantLinked: 'Je accountant werd succesvol toegevoegd!',
      successAccountantUnlinked: 'Je accountant werd succesvol verwijderd!',
      successBillitPaired: 'Je boekhoudpakket werd succesvol toegevoegd!',
      successCashacaPaired: 'Cashaca werd succesvol gekoppeld!',
      successForwardingEmailLinked: 'Het e-mailadres werd succesvol toegevoegd!',
      successForwardingEmailUnlinked: 'Het e-mailadres werd succesvol verwijderd!',
    },
    numberingSeries: {
      duplicateFormat: 'Het formaat van deze nummeringreeks heb je al gebruikt, kies je een nieuwe?',
      successCreated: 'Je nummeringreeks werd succesvol aangemaakt!',
      successDeleted: 'Je nummeringreeks werd succesvol verwijderd!',
      successUpdated: 'Je nummeringreeks werd succesvol gewijzigd!',
    },
    successUpdated: 'De instellingen werden succesvol opgeslagen!',
    validFinancialInfo: 'Geldige financiële gegevens',
  },
  documents: {
    headers: {
      name: 'Bestandsnaam',
      type: 'Type',
    },
    title: 'Documenten',
  },
  edit: 'Aanpassen',
  fields: {
    activities: {
      other: {
        label: 'Vul hier je extra (creatieve) activiteiten in',
      },
      primary: {
        label: 'Hoofdactiviteit',
      },
      secondary: {
        label: 'Extra activiteiten',
      },
    },
    brandId: {
      label: 'Handelsnaam',
    },
    brandName: {
      label: 'Handelsnaam',
      placeholder: 'Jouw handelsnaam',
    },
    city: {
      label: 'Stad of gemeente',
    },
    color: {
      label: 'Kleur',
    },
    communityDescription: {
      label: 'Biografie',
    },
    communityEmail: {
      label: 'Publieke e-mailadres',
    },
    communityLinks: {
      label: 'Links',
      placeholders: {
        behance: 'https://www.behance.net/',
        facebook: 'https://www.facebook.com/',
        instagram: 'https://www.instagram.com/',
        linkedIn: 'https://www.linkedin.com/in/',
        website: 'https://',
      },
    },
    communityOpenToWork: {
      label: 'Ik sta open voor opdrachten',
    },
    communityRegion: {
      label: 'Regio',
      placeholder: 'Niet gespecificeerd',
    },
    companyName: {
      label: 'Bedrijfsnaam',
    },
    currentPassword: {
      label: 'Huidig wachtwoord',
    },
    email: {
      label: 'E-mailadres',
      placeholder: 'E-mailadres',
    },
    firstName: {
      label: 'Voornaam',
      placeholder: 'Naam',
    },
    forwarding: {
      alerts: {
        billtobox: 'Vergeet niet om ‘administratie@creativeshelter.be’ als een gekend e-mailadres toe te voegen in Billtobox.',
      },
      frequency: {
        label: 'Frequentie',
        options: {
          instant: 'Per factuur of creditnota (.pdf/.xml)',
          monthly: 'Per maand (.zip)',
          quarterly: 'Per kwartaal (.zip)',
        },
        tooltip:
          'Als je een boekhoudpakket ingaf, kies dan voor de optie om per factuur of creditnota een pdf- en xml-bestand door te sturen.',
      },
      platformEmail: {
        label: 'E-mailadres van je Accountable account',
        tooltip: "Accountable herkent op basis van dit e-mailadres tot welk account je facturen en creditnota's behoren.",
      },
    },
    lang: {
      label: 'Taal',
    },
    lastName: {
      label: 'Achternaam',
      placeholder: 'Achternaam',
    },
    logo: {
      error: {
        delete: 'Er ging iets fout bij het verwijderen van het logo.',
        tooLarge: 'Het logo dat je probeert te uploaden mag niet groter zijn dan 5 MB.',
        upload: 'Er ging iets fout bij het uploaden van het logo.',
      },
      label: 'Handelsnaam logo',
      tooltip: 'Dit logo zal gebruikt worden op documenten in plaats van het standaard logo.',
    },
    mainOccupation: {
      label: 'Zelfstandige activiteit',
      options: {
        '0': 'Bijberoep',
        '1': 'Hoofdberoep',
      },
    },
    newPassword: {
      label: 'Nieuw wachtwoord',
    },
    newPasswordConfirmation: {
      label: 'Bevestig nieuw wachtwoord',
    },
    number: {
      label: 'Huisnummer',
    },
    numberingSeries: {
      blocker: 'Ben je zeker dat je de pagina wilt verlaten? De aanpassingen aan je nummeringreeks zijn niet opgeslagen.',
      format: {
        amountOfDigits: {
          label: 'Aantal cijfers',
          option: '{{amountOfDigits}} cijfers',
        },
        lengthWarning: 'We raden aan de lengte van het nummer te beperken tot {{limit}} karakters.',
        nextNumber: 'Het volgende nummer in deze reeks is <strong>{{number}}</strong>',
        prefixText: {
          label: 'Voorvoegsel',
        },
        separator: {
          label: 'Scheidingsteken',
          none: 'Geen',
        },
        suffixText: {
          label: 'Achtervoegsel',
        },
        useSuffix: 'Achtervoegsel gebruiken',
        year: {
          label: 'Jaar/maand',
          options: {
            YY: 'Jaar kort ({{yearMonth}})',
            YYMM: 'Jaar kort + maand ({{yearMonth}})',
            YYYY: 'Jaar ({{yearMonth}})',
            YYYYMM: 'Jaar + maand ({{yearMonth}})',
            none: 'Geen',
          },
        },
      },
      name: {
        label: 'Naam',
        placeholder: 'Bv. Verkoopfacturen',
        tooltip: 'Geef je nummeringreeks een naam, zo herken je deze snel.',
      },
      resetInterval: {
        description: 'Reset de telling automatisch naar 1.',
        label: 'Telling herstarten',
        options: {
          monthly: 'Maandelijks',
          never: 'Nooit',
          yearly: 'Jaarlijks',
        },
      },
      startAt: {
        label: 'Startnummer',
      },
      type: {
        label: 'Type',
        options: {
          both: "Facturen en creditnota's",
          credit_notes: "Creditnota's",
          invoices: 'Facturen',
        },
        tooltip:
          "In je boekhouding bestaan er twee belangrijke type documenten, je facturen of creditnota's. Aan jou de keuze om één nummeringreeks die beide omvat, maar een opsplitsing kan ook. Dat laten we aan jou over.",
      },
    },
    phone: {
      label: 'GSM-nummer',
      placeholder: '+32 4 999 999 99',
    },
    street: {
      label: 'Straatnaam',
    },
    vatID: {
      label: 'Btw-nummer',
    },
    zipcode: {
      label: 'Postcode',
    },
  },
  general: {
    customConditions: {
      create: 'Nieuwe voorwaarden',
      delete: {
        action: 'Verwijder',
        description: 'Ben je zeker dat je de custom algemene voorwaarde ({{name}}) wil verwijderen?',
        title: 'Verwijder custom algemene voorwaarden',
      },
      description: 'Bekijk hier het overzicht van al je custom algemene voorwaarden of maak er één aan.',
      table: {
        actions: {
          creatingPdf: 'Pdf aan het genereren...',
          delete: 'Verwijder',
          view: 'Bekijk',
        },
        name: 'Naam',
      },
      title: 'Custom algemene voorwaarden',
      wizard: {
        already_agreement: {
          question: 'Heb je al afgesproken met je opdrachtgever over hoe je werk mag gebruikt worden?',
        },
        already_agreement_no: {
          question: 'No worries! Aan de hand van volgende vragen bepaal jij wat je opdrachtgever met je werk mag doen.',
        },
        already_agreement_no_paper: {
          question: 'No worries! Aan de hand van volgende vragen zetten we ze op papier voor jou.',
        },
        already_agreement_paper: {
          question: 'Heb je die afspraken op papier?',
        },
        already_agreement_yes_paper: {
          question:
            "Perfect, goede afspraken maken goede vrienden. Duid in het profiel van de opdrachtgever aan dat je al een bestaande overeenkomst hebt en bezorg ons deze via e-mail (<a href='mailto:administratie@creativeshelter.be'>administratie@creativeshelter.be</a>). Wij nemen deze overeenkomst graag voor je onder de loep, en tekenen mee als derde partij.",
        },
        common_answers: {
          close: 'Ok, sluit de wizard',
          next: 'Ok, volgende vraag',
          no: 'Nee',
          ok: 'Ok',
          previous: 'Vorige vraag',
          start_questions: 'Ok, start de vragen',
          yes: 'Ja',
        },
        modify_how: {
          options: {
            '0': 'Te bewerken/wijzigen door elementen toe te voegen en/of weg te laten.',
            '1': 'Te vertalen/om te zetten.',
          },
          question: 'Hoe mag je werk bewerkt of gewijzigd worden?',
        },
        overview: {
          finish: 'Ok, maak mijn custom algemene voorwaarden aan.',
          name: {
            label:
              'Geef hier de naam in van je nieuwe custom algemene voorwaarden. Dit kan de naam van de opdrachtgever bevatten of de specifieke afspraken.',
            placeholder: "Bijvoorbeeld 'Gebruiksrecht Benelux 1 jaar'",
          },
          question: 'Bedankt, dat waren alle vragen! Hier kan je nog een overzicht terugvinden van je antwoorden:',
        },
        reproduce_how: {
          options: {
            '0': 'Op eender welke wijze, in eender welke vorm, met alle technieken en op alle dragers.',
            '1': 'In een specifieke vorm.',
            '2': 'In elektronische vorm op vaste informatiedrager.',
            '3': 'In elektronische vorm op online informatiedrager.',
          },
          other_placeholder: 'Specifieer je in welke vorm?',
          question: 'Op welke manier mag je werk gereproduceerd worden?',
        },
        reproduce_how_many: {
          options: {
            '0': 'Onbeperkt',
            '1': 'Beperkt',
          },
          other_placeholder: 'Specifieer het aantal',
          question: 'Op hoeveel exemplaren mag je werk gereproduceerd worden?',
        },
        share_how: {
          options: {
            '0': 'Publiceren in ...',
            '1': 'Ter beschikking via ...',
            '2': 'Opnemen in een boek, catalogus, ...',
            '3': 'Als promomateriaal en voor commerciële doeleinden.',
          },
          other_placeholder: 'Specificeer',
          question: 'Op welke manier mag je werk meegedeeld worden?',
        },
        start: {
          description: 'Volg onderstaande wizard om je eigen custom algemene voorwaarden samen te stellen.',
          ok: 'Ok, start de wizard',
          title: 'Maak je custom algemene voorwaarden',
        },
        thanks: {
          close: 'Sluit de wizard',
          explanation:
            "Maak je factuur aan en selecteer de naam van je custom AV's onderaan het keuzemenu 'afspraak auteursrechten'. Je AV's op maat zijn automatisch opgenomen in de bijlage die we samen met onze factuur aan je opdrachtgever sturen onder artikel 8 (8.1 tot en met 8.3). Ook in het veld bijzondere voorwaarden op onze factuur aan je opdrachtgever wordt er verwezen naar custom AV's.",
          question:
            'Je custom algemene voorwaarden worden nu voor je gemaakt. Je kan ze binnenkort bekijken en gebruiken bij de aanmaak van je factuur!',
          subtitle: 'Hoe ga ik aan de slag?',
        },
        transfer_copyright: {
          question: 'Wil je je auteursrechten op je werk overdragen aan je opdrachtgever?',
        },
        transfer_copyright_no: {
          question: 'Ok top, je dient dan aan te geven wat er met je werk mag gebeuren.',
        },
        transfer_copyright_yes: {
          question: "Ok, ideaal! Kies dan voor 'overdracht' bij het aanmaken van een offerte of factuur.",
        },
        use_how: {
          options: {
            '0': 'Reproducties maken',
            '1': 'Publiekelijk meedelen',
            '2': 'Bewerken/wijzigen',
          },
          question: 'Wat mag je opdrachtgever doen met je werk?',
        },
        use_how_long: {
          options: {
            '0': 'Volledige duurtijd',
            '1': 'Andere periode',
          },
          other_placeholder: 'Specifieer de periode',
          question: 'Hoe lang mag je opdrachtgever je werk gebruiken?',
        },
        use_where: {
          options: {
            '0': 'België',
            '1': 'Europa',
            '2': 'De hele wereld',
            '3': 'Andere',
          },
          other_placeholder: 'Bijvoorbeeld Benelux',
          question: 'Waar mag je opdrachtgever je werk gebruiken?',
        },
      },
    },
    description: 'Wijzig de lay-out en de werking van jouw Craft-platform.',
    email: {
      bcc: {
        description:
          "Dit houdt in dat je in bcc staat bij alle e-mails die we naar je klanten versturen, van nieuwe offertes, facturen en creditnota's tot betalingsherinneringen van facturen.",
        title: 'Zet mij in bcc bij alle e-mails naar mijn klanten',
      },
      description: 'Kies hier welke e-mails en notificaties je wilt ontvangen',
      followUpEnabled: {
        description: 'Krijg een melding wanneer er een update is voor een betalingsopvolging',
        title: 'Updates van betalingsopvolgingen',
      },
      invitationReminder: {
        description:
          'Krijg een reminder als de collega-freelancer die je uitnodigde, op zijn of haar beurt een herinnering krijgt om zich te registeren.',
        title: 'Herinnering over verstuurde uitnodigingen',
      },
      jobPostUpdates: {
        description:
          'Krijg een wekelijks overzicht van nieuw geplaatste opdrachten gefiltered op basis van jouw hoofd- en nevenactiviteiten.',
        title: 'Wekelijks overzicht nieuwe opdrachten',
      },
      nettoSaved: {
        description:
          'Krijg een overzicht van wat je maandelijks bespaart door Creative Shelter te gebruiken. Zo zie je zwart op wit wat je extra verdient door je auteursrechten te verzilveren.',
        title: 'Maandelijkse e-mail over nettobesparingen',
      },
      title: 'E-mails & notificaties',
    },
    numberingSeries: {
      add: 'Nieuwe nummeringreeks',
      delete: {
        description: 'Ben je zeker dat je "{{numberingSeries}}" wil verwijderen?',
        title: 'Verwijderen',
      },
      description:
        'Configuratie voor automatische nummering van facturen en creditnota\'s. Vragen, meer info vind je <a href="https://knowledge.creativeshelter.be/wat-is-een-nummeringreeks-en-hoe-stel-ik-deze-in" target="_blank">hier</a>.',
      edit: {
        format: 'Formaat/opties wijzigen',
        name: 'Naam/type wijzigen',
      },
      headers: {
        name: 'Naam',
        nextNumber: 'Volgend nummer',
        type: 'Type',
      },
      title: 'Nummeringreeksen',
    },
    themeInvoice: {
      colorTheme: {
        helpText: 'Kies de kleuren die gebruikt worden voor de documenten naar jouw klanten.',
        subtitle: 'Kleurenthema',
      },
      logo: {
        helpText: 'Upload hier je logo die te zien zal zijn op je factuur',
      },
      title: 'Factuur opmaak',
    },
    title: 'Instellingen',
  },
  integrations: {
    accountant: {
      current: 'Onderstaande accountant is toegevoegd aan je account:',
      description:
        'Door je accountant toe te voegen, krijgt die toegang tot jouw facturen en documenten via <a href=https://api.creativeshelter.be/accountants/login target="_blank">het Credit-platform</a> van Creative Shelter.',
      pair: 'Accountant toevoegen',
      requested: 'Onderstaande accountant heeft toegang gevraagd tot jouw account:',
      title: 'Geef je accountant toegang',
      unpair: 'Verwijderen',
    },
    description: 'Koppel hier je Creative Shelter account met externe services.',
    externalSystems: {
      createAccount: 'Account aanmaken',
      peppolWarning:
        "Facturen en creditnota's die via Peppol verstuurd worden, kunnen dubbel binnenkomen in je koppeling. Controleer de instellingen van je boekhoudtool om dubbele verwerking te vermijden.",
      description:
        'Door de koppeling met een extern systeem breid je de functionaliteit van je account uit met die van het externe systeem.',
      pairWith: 'Koppelen met {{ system }}',
      paired: 'Gekoppeld',
      systems: {
        billit: {
          description:
            'Maak je naast creatieve facturen ook wel eens niet-creatieve facturen aan? Deze integratie maakt het mogelijk om die niet-creatieve facturen eenvoudig aan te maken en te koppelen aan je Creative Shelter account.',
          name: 'Billit',
        },
        cashaca: {
          description: 'Cashaca vereenvoudigt boekhouding. Dit is ideaal voor zelfstandigen met een omzet van minder dan 500.000 euro.',
          modal: {
            apiToken: 'Cashaca API code',
            description:
              'Geef hier je persoonlijke Cashaca API code in.<br/>Heb je nog geen Cashaca account? <a href="https://app.cashaca.be/gebruikers/registreer?utm_source=creativeshelter" target="_blank">Registreer je dan hier</a>.',
          },
          name: 'Cashaca',
        },
        dexxter: {
          alerts: {
            error: 'Er is iets misgelopen tijdens het koppelen van je Dexxter-account.',
            success: 'De koppeling met Dexxter is succesvol gemaakt.',
          },
          description:
            'Facturen automatisch doorsturen naar Dexxter. Alles wat je nodig hebt om als eenmanszaak je boekhouding zelf te doen binnen handbereik.',
          modal: {
            description:
              'Stuur je facturen en creditnota\'s door naar Dexxter in twee snelle stappen:<ol><li>Ga eerst naar je instellingen en klik op ‘<dexxterLink href="https://go.dexxter.be/user-settings/general/company-settings">Algemeen</dexxterLink>’. Vink de optie ‘Activeer auteursrechten’ aan en sla op.</li><li>Ga naar ‘Inkomsten’ en klik op ‘<dexxterLink href="https://go.dexxter.be/income-documents">Inbox</dexxterLink>’. Binnen de Inbox klik je op ‘Bekijk aanlevermethode’ en kopieer je het e-mailadres van je digitale brievenbus. Deze vul je hieronder in.</li></ol>',
            emailAddress: {
              placeholder: 'income.xxxxxxxxxxxxxxxx',
              suffix: '@inbound.dexxter.be',
              validatePrefix: "Het e-mailadres moet starten met 'income.'.",
              validateSuffix: "Vul enkel het deel voor de '@' in.",
            },
            title: 'Koppelen met Dexxter',
            titleTooltip:
              'Meer info vind je <faqLink href="https://www.creativeshelter.be/knowledge-hub/hoe-stuur-ik-mijn-facturen-automatisch-door-naar-dexxter">hier in onze Knowledge Base</faqLink>',
          },
          name: 'Dexxter',
          tag: 'Krijg € 25 korting',
        },
      },
      title: 'Koppelen aan externe systemen',
    },
    forwarding: {
      deleteModal: {
        confirm: 'Ja, ik ben zeker.',
        description: "Ben je zeker dat je jouw facturen en creditnota's niet langer wilt doorsturen naar {{email}}?",
        dexxter: {
          confirm: 'Ja, koppeling verwijderen.',
          description: "Ben je zeker dat je jouw facturen en creditnota's niet langer wilt doorsturen naar Dexxter?",
          title: 'Dexxter-koppeling verwijderen',
        },
        title: 'Stoppen met automatisch doorsturen',
      },
      description: "Stuur jouw facturen en creditnota's automatisch door naar jouw accountant of boekhoudpakket.",
      peppol: {
        description:
          'Je ontvangt je facturen al in je Peppol inbox. Het is dus niet meer nodig om deze automatisch door te sturen, tenzij je accountant er specifiek om vraagt.',
        title: 'Peppol geactiveerd',
      },
      add: 'Voeg ontvanger toe',
      blocker: 'Ben je zeker dat je de pagina wilt verlaten? De aanpassingen aan je doorstuuradres zijn niet opgeslagen.',
      title: "Automatisch doorsturen facturen en creditnota's",
    },
    pair: 'Koppelen',
    peppol: {
      actions: {
        checkAgain: 'Opnieuw controleren',
      },
      confirmExtraIntegration: {
        cancel: 'Niet koppelen',
        confirm: 'Toch koppelen',
        description:
          'Je ontvangt je facturen al in je Peppol-inbox. Een extra koppeling is meestal niet nodig, tenzij je accountant of boekhoudpakket er specifiek om vraagt. Ben je zeker dat je wil verdergaan?',
        title: 'Extra koppeling nodig?',
      },
      description: 'Leuke ondertekst voor Peppol',
      disclaimerSelfBillingUnsupported: 'Dit gaat actief zijn vanaf 2026.',
      fields: {
        peppolId: {
          empty: 'Nog geen Peppol-ID',
          label: 'Peppol-ID',
          tooltip:
            'Deze Peppol ID hebben we voor jou gevonden. Niet correct? Contacteer <email href="mailto:service@creativeshelter.be">support</email> en we passen het aan.',
        },
        status: {
          label: 'Status',
          options: {
            Active: 'Geactiveerd',
            ActiveSelfBillingFallback: 'Self-billing niet geactiveerd',
            NotRegistered: 'Geen Peppol ID gevonden',
          },
        },
      },
      title: 'Peppol',
    },
    processing: 'We halen je data op',
    title: 'Integraties',
    unpair: 'Ontkoppelen',
  },
  nps: {
    placeholderTextarea: 'Schrijf hier je mening...',
    ariaLabelTextarea: 'Schrijf hier je mening',
    sendFeedback: 'Versturen',
    eyebrow: 'Jouw mening telt',
    titleStepOne: 'In welke mate zou je Creative Shelter aanbevelen bij andere freelancers?',
    titleStepThree: 'Bedankt! We gaan met je feedback aan de slag!',
  },
  profile: {
    activities: {
      title: 'Activiteiten',
      warnings: {
        stylingAndInterior: {
          body: 'Vanaf 2024 komen niet alle creatieve styling/interieur prestaties nog in aanmerking voor een auteursvergoeding. De interpretatie van de wet is strenger dan de wet zelf. Twijfel je of je prestatie in aanmerking komt? <a href="mailto:administratie@creativeshelter.be?subject=Komen mijn prestaties voor styling/interieur nog in aanmerking?" target="_blank">Mail ons</a>, en we pikken het met je op. Voor andere creatieve activiteiten kom je nog steeds in aanmerking.',
          title: 'Belangrijk! Stylist/interieur-vormgever, lees je even verder?',
        },
      },
    },
    brands: {
      add: 'Handelsnaam toevoegen',
      delete: {
        description: 'Ben je zeker dat je "{{brand}}" wil verwijderen?',
        title: 'Handelsnaam verwijderen',
      },
      description: 'Bekijk, creëer en bewerk je handelsnamen',
      edit: 'Handelsnaam aanpassen',
      favorite: {
        markAsFavorite: 'Markeren als favoriet',
        removeFavorite: 'Verwijderen als favoriet',
      },
      headers: {
        color: 'Handelsnaam kleur',
        email: 'E-mailadres',
        logo: 'Logo',
        name: 'De naam van je handelsnaam',
      },
      logoAdd: 'Standaard logo toevoegen',
      logoEdit: 'Standaard logo bewerken',
      mainBrand: 'Hoofdhandelsnaam',
      title: 'Handelsnamen',
    },
    community: {
      communityHidden: 'De toegang tot de community werd voor jou uitgeschakeld, neem contact op met een administrator voor meer info.',
      visibleInCommunity: 'Zichtbaar in community',
      description: 'Jouw profielpagina is zichtbaar in de community. Zo kan je connecteren met andere freelancers.',
      title: 'Publieke profielpagina',
    },
    financial: {
      bank: 'Naam bank',
      bic: 'BIC/SWIFT',
      check: 'Controleren',
      error: {
        foreignIban: 'We ondervonden problemen tijdens het ophalen van je bankinformatie, gelieve zelf aan te vullen.',
        general: 'Er ging iets mis bij het opslaan van je IBAN-nummer.',
      },
      iban: 'IBAN',
      title: 'Financiële gegevens',
    },
    info: {
      language: {
        en: 'Engels',
        fr: 'Frans',
        nl: 'Nederlands',
      },
      refreshKboInformation: {
        action: 'Gegevens refreshen',
        lastUpdated: '{{timeAgo}} opgehaald uit de Kruispuntbank voor Ondernemingen',
        tooltip:
          'Deze gegevends halen we op uit de <kboLink>Kruispuntbank van Ondernemingen</kboLink>. Is er iets gewijzigd? Dan kan je hier de nieuwste gegevens ophalen. (Enkel mogelijk indien de gegevens ouder zijn dan 7 dagen).',
        unavailable_one: 'Je gegevens zijn net opgehaald. Je kan ze over 1 dag opnieuw refreshen.',
        unavailable_other: 'Je gegevens zijn net opgehaald. Je kan ze over {{count}} dagen opnieuw refreshen.',
      },
      companyTitle: 'Gegevens onderneming',
      kboDescription: 'Deze gegevens komen uit de databank van het KBO.',
      subsections: {
        kbo: 'Gegevens onderneming',
        personal: 'Persoonlijke informatie',
      },
      title: 'Persoonlijke gegevens',
    },
    password: {
      edit: 'Wachtwoord wijzigen',
      title: 'Wachtwoord veranderen',
    },
    title: 'Profiel',
    vatRegulation: {
      description:
        'Bepaalt of btw aangerekend wordt op facturen tussen jou en Creative Shelter. Kleine ondernemingen met een omzet onder €25.000 kunnen de standaard btw-vrijstellingsregeling aanvragen. <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target="_blank">Meer informatie</a>',
      edit: 'Aanpassen',
      help: 'Duid aan welke btw-status je gebruikt. Dit bepaalt of er btw zal aangerekend worden op jouw facturen. Kleine ondernemingen met een omzet onder 25.000 euro kunnen de btw-vrijstellingsregeling volgen, dit kan je zelf aanvragen. Meer informatie vind je <a href="https://knowledge.creativeshelter.be/wat-is-de-btw-vrijstellingsregeling-en-bestaan-er-nog-andere-regelingen" target=”_blank”>hier</a>.',
      info: {
        none: 'Je hebt jouw btw-status nog niet aangeduid.',
        vatExempt:
          'Je maakt gebruik van de <strong>btw-vrijstellingsregeling</strong>. Facturen tussen jou en Creative Shelter worden opgemaakt zonder btw. Volg hieronder op hoe ver je van de limiet zit.',
        vatNormal:
          'Je maakt gebruik van de <strong>gewone btw-status</strong>. Facturen tussen jou en Creative Shelter worden opgemaakt met btw.',
      },
      limit: 'Limiet vrijstellingsregeling {{year}}',
      options: {
        vatExempt: {
          description: 'Kleine ondernemingen met een omzet onder de €25.000',
        },
        vatNormal: {
          description: 'Ondernemingen met een omzet meer dan €25.000',
        },
      },
      title: 'Btw-status',
      toggle: {
        vatExempt: 'Btw-vrijgesteld',
        vatNormal: 'Btw-plichtig',
      },
      toggleDescription: {
        vatExempt: 'Kleine ondernemingen met een omzet onder de €25.000',
        vatNormal: 'Ondernemingen met een omzet meer dan €25.000',
      },
      tooltip: 'Als je omzet hoger is dan 25.000 euro, mag je geen gebruik meer maken van de btw-vrijstellingsregeling.',
      totalRevenueInYear: 'Totale omzet {{ year }}',
      yearSelector: {
        ariaLabel: 'Selecteer het jaar waarvoor je de omzetlimiet wil bekijken.',
      },
    },
  },
  prompts: {
    verifyAddress: {
      change: {
        actions: {
          back: 'Terug',
          mail: 'Mail ons',
        },
        description:
          'Verhuisd? Geef ons een seintje door ons te mailen. Zo kunnen we het voor jou aanpassen in je Creative Shelter profiel.',
        kboMessage:
          'Vergeet zeker niet je adres ook aan te passen in de Kruispuntbank voor Ondernemingen (via <myEnterpriseLink>My Enterprise</myEnterpriseLink>).',
        mailLink: 'mailto:service@creativeshelter.be?subject=Adres wijzigen&body=Hey%0D%0A%0D%0AMijn adres',
        title: 'Adres wijzigen',
      },
      verify: {
        actions: {
          confirm: 'Bevestigen',
          edit: 'Aanpassen',
          refresh: 'Opnieuw ophalen',
        },
        description: 'Je adres hebben we opgeslagen als volgt. Bevestig je even of dit nog klopt?',
        errors: {
          refreshKboFailed: 'Gegevens kunnen momenteel niet opgehaald worden uit de Kruispuntbank voor Ondernemingen.',
        },
        title: 'Adres bevestigen',
      },
    },
  },
};
